export function useMobileOs() {
  const mobileOs = ref('')

  onMounted(() => {
    const userAgent = window?.navigator?.userAgent

    if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
      mobileOs.value = 'ios'
    } else if (userAgent.includes('Android')) {
      mobileOs.value = 'android'
    }
  })

  return mobileOs
}
